import React from 'react'
import _ from 'lodash'
import { ICellRendererParams } from 'ag-grid-community'
import { FunctionProperty } from '../../../../../../../../lib/commons/appFunction'
import { WbsItemRow } from '../../../../../../../../lib/functions/wbsItem'
import ProjectAPI, {
  ProjectDetail,
} from '../../../../../../../../lib/functions/project'
import { getProjectPlanUuidByWbsItemUuid } from '../../../../../../../../lib/functions/projectPlan'
import ViewMeta from '../../../../../../meta/ViewMeta'
import { WbsItemIcon } from '../../../../../../../components/icons/WbsItemIcon'
import IconTextField from '../../common/iconText'
import { WbsItemTypeVO } from '../../../../../../../../domain/value-object/WbsItemTypeVO'

interface Props extends ICellRendererParams {
  value: Partial<WbsItemRow>
  data: any
  uiMeta: FunctionProperty
  viewMeta: ViewMeta
}

class WbsItemBasicCellRenderer extends React.PureComponent<Props> {
  // 描画に影響するpropsのみを比較
  shouldComponentUpdate(nextProps: Props): boolean {
    const prevWbsItem = this.props.value
    const nextWbsItem = nextProps.value

    // valueが両方nullish
    if (!prevWbsItem && !nextWbsItem) return false
    // 片方だけnullish
    if (!prevWbsItem || !nextWbsItem) return true

    // 描画に関係するプロパティを比較
    if (prevWbsItem.displayName !== nextWbsItem.displayName) return true
    if (prevWbsItem.wbsItemType !== nextWbsItem.wbsItemType) return true
    if (prevWbsItem.projectUuid !== nextWbsItem.projectUuid) return true
    if (prevWbsItem.uuid !== nextWbsItem.uuid) return true

    return false
  }

  canOpenProjectPlan = (): boolean => {
    const wbsItemType: WbsItemTypeVO | undefined = this.props.value?.wbsItemType
    return (
      !!wbsItemType &&
      (wbsItemType.isWorkgroup() ||
        wbsItemType.isProcess() ||
        wbsItemType.isDeliverableList() ||
        (wbsItemType.isTicket() && wbsItemType.isDeliverable()))
    )
  }

  openProjectPlan = async () => {
    if (!this.canOpenProjectPlan()) {
      return
    }

    let project: ProjectDetail | undefined = undefined
    if (this.props.value?.projectUuid) {
      const response = await ProjectAPI.getDetail({
        uuid: this.props.value.projectUuid,
      })
      project = response?.json as ProjectDetail
    }
    if (!project || !this.props.value?.uuid) {
      return
    }

    const projectPlanUuid = await getProjectPlanUuidByWbsItemUuid(
      this.props.value.uuid
    )
    window.open(
      `${window.location.origin}/projectPlan/${project.code}?treeRootUuid=${projectPlanUuid}`
    )
  }

  render() {
    const wbsItem = this.props.value
    if (!wbsItem) {
      return <></>
    }
    return (
      <IconTextField
        icon={<WbsItemIcon type={wbsItem.wbsItemType} />}
        enableTooltip={false}
        onIconClicked={
          this.canOpenProjectPlan() ? this.openProjectPlan : undefined
        }
        value={wbsItem.displayName ?? ''}
        data={this.props.data}
        uiMeta={this.props.uiMeta}
        viewMeta={this.props.viewMeta}
      />
    )
  }
}

export default WbsItemBasicCellRenderer
